import { Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { FormBuilder, FormGroup, Validators } from "@angular/forms";
@Component({
  selector: "examination-card",
  templateUrl: "examination-card.html",
})
export class ExaminationCard implements OnInit {
  @Input() config;
  @Output() onDataUpdate: EventEmitter<any> = new EventEmitter();
  @Output() onCardInitialized: EventEmitter<any> = new EventEmitter();

  label: string;
  layout: any;
  inputs: any;
  radioInputs: any;
  formGroup: FormGroup;
  access: string;
  cardData: any;
  initialized: boolean = false;

  constructor(private formBuilder: FormBuilder) {}

  public ngOnInit(): void {
    this.layout = this.config.layout;
    this.label = this.config.cardName;
    this.access = this.config.access;
    this.inputs = Object.values(this.config.inputs).sort((a: any, b: any) => {
      return a.sortOrder - b.sortOrder;
    });
    this.radioInputs = this.inputs.filter((i) => i.type === "radio");
    this.formGroup = this.formBuilder.group({});
    for (let key of this.inputs) {
      this.formGroup.addControl(
        key.componentId,
        this.formBuilder.control(undefined)
      );
      if (key.type === "radio") {
        this.formGroup.controls[key.id].valueChanges.subscribe((data) => {
          if (data === "abnormal") {
            this.formGroup
              .get(key.id + "Text")
              .setValidators([Validators.required]);
            this.formGroup.get(key.id + "Text").enable();
          } else if (data === "normal") {
            this.formGroup.get(key.id + "Text").clearValidators();
            this.formGroup.get(key.id + "Text").enable();
          }
          this.formGroup.get(key.id + "Text").updateValueAndValidity();
        });
      }
    }
    this.formGroup.valueChanges.subscribe((data) => {
      this.cardData = data;
      this.onDataUpdate.emit({ cardId: this.config.id, value: data });
    });
  }
  public clear(toClear): void {
    const radioAndTextInput = [toClear, toClear + "Text"];
    radioAndTextInput.forEach((item) => {
      this.formGroup.get(item).setValue(null);
      this.formGroup.get(item).clearValidators();
      this.formGroup.get(item).updateValueAndValidity();
    });
  }

  @Input() set data(incomingData: any) {
    this.cardData = incomingData;
    if (incomingData && incomingData.data && incomingData.data[0]) {
      const data = incomingData.data[0];
      for (let key of Object.keys(data)) {
        if (this.formGroup.controls[key]) {
          this.formGroup.controls[key].setValue(data[key]);
        }
      }
    }
    if (incomingData !== undefined && !this.initialized) {
      this.initialized = true;
      this.onCardInitialized.emit(this.config.id);
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/configurable/cards/examination-card/examination-card.ts